import About4 from '../../images/about-4.jpg';
import Wedding from '../../images/wedding-cake.jpg';

export const homeObjOne = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    headline: 'We create unforgettable culinary experiences',
    description:
      'We´re known for our creative talent when it comes to providing birthday cakes, wedding cakes, bridal shower cakes, baby shower cakes, custom cake or desserts for anu occasion',
    buttonLabel: 'Get Started',
    imgStart: '',
    img: `${About4}`,
    alt: 'Dessert'
};
  
export const homeObjTwo = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  lightTopLine: false,
  headline: 'Personalized attention',
  description:
    'We suggest an initial consultation for your wedding cake be at least six months prior to your wedding day. However, we will accommodate to your timing as best as we can.  Contact us at (123) 456-7890 to schedule your appointment! Feel free to bring any pictures or drawings you would like our designer to reference.',
  imgStart: 'start',
  img: `${Wedding}`,
  alt: 'Dessert'
};